module.exports = __webpack_public_path__ + "img/hear_img.ace6d1a.png";